import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Role = 'SUPER_ADMIN' | 'TENANT_ADMIN' | 'TENANT_MEMBER';

export interface AuthUser {
  user_id: string;
  username: string;
  display_name: string;
  email?: string | null;
  role: Role;
  tenant_id: string | null;
}

interface AuthState {
  token: string | null;
  user: AuthUser | null;
}

interface AuthActions {
  setSession: (token: string, user: AuthUser) => void;
  setUser: (user: AuthUser) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState & AuthActions>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setSession: (token, user) => set({ token, user }),
      setUser: (user) => set({ user }),
      clear: () => set({ token: null, user: null }),
    }),
    { name: 'starfox-auth' },
  ),
);

export const isAuthenticated = () => Boolean(useAuthStore.getState().token);
export const currentRole = () => useAuthStore.getState().user?.role ?? null;
export const isSuperAdmin = () => currentRole() === 'SUPER_ADMIN';
export const isTenantAdmin = () => {
  const r = currentRole();
  return r === 'TENANT_ADMIN' || r === 'SUPER_ADMIN';
};
